import AddIcon from '@mui/icons-material/Add'
import React, {useEffect, useState} from 'react'
import {
    Container,
    Body,
    Header,
    SignalSet,
    SignalSetElem,
    AddSet,
    HeadButton, Header2,
} from './Interpretations.style'
import TitleDescriptionInput from '../../../components/customInput/TitleDescriptionInput'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {useLocation} from 'react-router-dom'
import {initCurrent, updateCurrent} from '../../../redux/slice/currentItem'
import _ from 'underscore'
import IdRecommendationsTable from '../../../components/tables/[id]/recommendations/IdRecommendations'
import IdInterPretationsTable from '../../../components/tables/[id]/interpretations/IdInterpretetions'
import {objectify} from '../../recommendations/[id]/Recommendations'
import ConnectToRecommendationTable from '../../../components/tables/connectTo/recommendations/connectToRecommendation'
import ConnectToSignalsTable from '../../../components/tables/connectTo/signals/signals'
import {ConnectModal} from '../../../components/customStyledElements'
import IndicatorsSignalTable from "../../../components/tables/main/indicators-signals-table/IndicatorsSignalTable";
import {Button, Checkbox, Input, MenuItem, Modal, Select} from "@mui/material";
import MyModal from '../../../components/myModal/myModal'
import RecommendationsTable from "../../../components/tables/main/recommendation/RecommendationTable";
import {RemoveBtn} from "../../../components/listMenu/listMenu";
import {patchRemove} from "../../../redux/slice/data";
import WarningIcon from '@mui/icons-material/WarningTwoTone';
import {WarningCircle} from '../../biomarkers/[id]/IndicatorsAndSignals'
import {getScaleTypeColor} from "../../subjects/Subject";
import {DialogMUI} from '../../biomarkers/[id]/components/FiltersComponent.styles'
import CloseIcon from "@mui/icons-material/Close";
import getUnitType from "../../../components/tables/typeName";

const CONNECT_TO = {
    SIGNALS: 0,
    RECOMMENDATIONS: 1,
}
let str = '1,2,3\n4,5,6\n7,8,9';

const CSVUploader = (props: any) => {
    let {onChange} = props;
    const {interpretations, indicators, recommendations} = useAppSelector(
        (state) => state.data
    )
    let [checked, setChecked] = useState(false)
    let [isModalOpen, setIsModalOpen] = useState(false)
    let [stage, setStage] = useState('start')
    let [checkboxes, setCheckboxes] = useState({})
    let [csv, setCsv] = useState('')
    // let [csv, setCsv] = useState(str)
    let [indexes, setIndexes] = useState<any[]>([])
    let [filter, setFilter] = useState<any>({hashTagInd: 0})
    let [csvArr, setCsvArr] = useState([])
    let [assignedValues, setAssignedValues] = useState<any>({
        "4": {
            "type": "biomarker",
            "_id": 1023,
            "signalIndex": 0
        },
        // "значение 4": {
        //     "type": "biomarker",
        //     "_id": 1028,
        //     "signalIndex": 2
        // },
        "6": {
            "type": "currentInterpretation"
        }
    })
    let [uniqueValues, setUniqueValues] = useState<any>({})
    let [parsedValues, setParsedValues] = useState<any[]>([])
    let [uniqueValuesArr, setUniqueValuesArr] = useState<any[]>([])


    const isGoodFilterInd = (ind: number) => {
        if (filter.hashTagInd && (+filter.hashTagInd - 1) == ind) {
            return false;
        }

        if (filter.hashTagInd2 && (+filter.hashTagInd2 - 1) == ind) {
            return false;
        }
        return true;
    }

    useEffect(() => {
        let value = csv;

        let arr = (value as any).split('\n').map((it: string) => it.split(','))
        let values: any = {};


        _.each(arr, (itemArr, ind) => {
            _.each(itemArr, (item, ind2) => {
                if (ind > 0 && isGoodFilterInd(ind2)) {
                    // console.log("qqqqq is good filter", isGoodFilterInd(ind2));
                    // if (isGoodFilterInd(ind2)) {
                    let str: string = String(item || '').trim();
                    itemArr[ind2] = str;
                    values[str] = ((values[str] || 0) + 1);
                }
            })
        })

        setCsvArr(arr)
        setIndexes([0, ...arr[0].map((it: any, ind: number) => (ind + 1))])
        setUniqueValues(values)
        setUniqueValuesArr(_.sortBy(Object.keys(values), it => (-1) * values[it]));

        let checkboxes: any = {};
        let parsed = getParsedValues(arr)
        _.each(parsed, (item, ind) => {
            if (item.isCurInterpretation) {
                checkboxes[ind] = true;
            }
        })

        setCheckboxes(checkboxes)
    }, [csv, JSON.stringify({...filter, sortBy: null})])

    const getParsedValues = (_csvArr?: any) => {
        let res: any[] = []
        let _arr = _csvArr?.length ? _csvArr : csvArr
        _.each(_arr, (item, parentInd) => {

            if (parentInd > 0) {
                let value: any = {
                    byCheckboxes: {},
                    isCurInterpretation: false,
                    hashName: item[+filter.hashTagInd - 1] || '',
                    names: item.join(', ')
                }

                _.each(item, (it, ind) => {
                    if (isGoodFilterInd(ind)) {
                        let avalue = assignedValues[it];
                        (global as any).av = assignedValues;
                        let isBio = isBioFn(avalue);
                        if (isIgnoreFn(avalue)) {
                            return;
                        }
                        if (isBio) {
                            // value.signals.push(avalue)
                            value.byCheckboxes[avalue?._id] = value.byCheckboxes[avalue?._id] || {}
                            value.byCheckboxes[avalue?._id][avalue?.signalIndex || 0] = true;
                            // value.names[`${avalue?._id}_${avalue?.signalIndex || 0}`] = it;
                        } else if (avalue?.type == 'currentInterpretation') {
                            // value.interpretation = avalue;
                            // value.names[`currentInterpretation`] = it;
                            value.isCurInterpretation = true
                        }

                    }


                })

                value.ind = parentInd;
                res.push(value)
            }
        })
        return res
    }


    let indicatorsArr = Object.keys(indicators).map(it => indicators[it]);//[{name: '123', _id: 444}]
    let interpretationsArr = Object.keys(interpretations).map(it => interpretations[it]);//[{name: '123', _id: 444}]

    const isBioFn = (avalue: any) => {
        return avalue?.type == 'biomarker'
    }

    const isIgnoreFn = (avalue: any) => {
        return avalue?.type == 'ignore'
    }

    const migrate = () => {
        onChange(parsed.filter((it, ind: number) => {
            let value = (checkboxes as any)[ind + 1];
            return value
        }))
        setIsModalOpen(false)
    }


    let parsed = getParsedValues();

    useEffect(() => {
        if (stage === 'preview') {
            let obj: any = {}
            _.each(parsed, (item, ind) => {
                if (item.isCurInterpretation) {
                    obj[ind + 1] = true;
                }
            })

            setCheckboxes(obj)
        }
    }, [stage])
    let onClose = () => setIsModalOpen(false)

    console.log("qqqqq chbx", checkboxes, parsed);
    let isEditor = (global as any)?.isEditor;

    return (<>
        <button
            disabled={!isEditor}
            className={'btn big'} onClick={() => {
            setIsModalOpen(true)
            setStage('start')
        }}>Upload Excel
        </button>
        <div></div>
        <DialogMUI
            style={{padding: '0px'}}
            scroll='body'
            maxWidth={'md'}
            aria-labelledby='scroll-dialog-title'
            aria-describedby='scroll-dialog-description'
            onClose={() => setIsModalOpen(false)}
            open={isModalOpen}
        >

            <div data-animch>
                {stage == 'start' && <>
                    <NextPrev prev={'disabled'} next={'config'} setStage={setStage} onClose={onClose}></NextPrev>
                    <div></div>
                    <label htmlFor="">Insert CSV File Content</label>
                    <textarea style={{height: '500px', width: '100%', maxWidth: '100%'}} value={csv} onChange={(e) => {
                        setCsv(e.target.value)
                    }}></textarea></>}
                {stage == 'config' && <>
                    <NextPrev prev={'start'} next={'preview'} setStage={setStage} onClose={onClose}></NextPrev>

                    <label htmlFor="">Tab Configuration</label>

                    <div></div>
                    <div className="ib">
                        <IndFilter filter={filter} setFilter={setFilter} name={'Select Column with Scenario #'}
                                   field={'hashTagInd'}
                                   indexes={indexes}></IndFilter>
                    </div>
                    <div className="ib ml10">
                        <IndFilter filter={filter} setFilter={setFilter} name={'Select Columns to Ignore'}
                                   field={'hashTagInd2'}
                                   indexes={indexes}></IndFilter>
                    </div>
                    <hr/>
                    <label>Unique values to config:</label>

                    <table className={'table tableBig'} border={1}>
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th style={{width: '100px'}}>Count</th>
                            <th>Details</th>
                        </tr>
                        </thead>
                        {(uniqueValuesArr || []).map((it, ind) => {
                            // it = (it || '').trim('')
                            let avalue = assignedValues[it] || {};
                            let atype = avalue?.type;
                            let _id = avalue?._id;
                            let isBio = isBioFn(avalue)
                            let indic = (indicators[_id] || {})
                            const signalColors = isBio ? getScaleTypeColor(indic.scaleType?.name || 'RAGAR') : []

                            return (<tr key={ind}>
                                <td>
                                    {it}
                                </td>
                                <td>
                                    [x{uniqueValues[it]}]
                                </td>
                                <td>
                                    <Select
                                        size={'small'}
                                        value={avalue.type} onChange={(e) => {
                                        setAssignedValues({
                                            ...assignedValues,
                                            [it]: {...avalue || {}, type: e.target.value}
                                        })
                                    }}>
                                        <MenuItem value={'biomarker'}>Biomarker</MenuItem>
                                        <MenuItem value={'currentInterpretation'}>Current Diseases</MenuItem>
                                        <MenuItem value={'ignore'}>Ignore</MenuItem>
                                    </Select>
                                    {isBio && <Select
                                        size={'small'} value={avalue._id} onChange={(e) => {
                                        setAssignedValues({
                                            ...assignedValues,
                                            [it]: {...avalue || {}, _id: e.target.value}
                                        })
                                    }}>
                                        {(avalue.type === 'biomarker' ? indicatorsArr : interpretationsArr || []).map((it, ind) => {
                                            return (<MenuItem key={ind} value={it._id}>
                                                {typeof it.name === 'object' 
                                                    ? it.name?.en || it.name?.[Object.keys(it.name || {})[0]] || ''
                                                    : it.name || ''} {isBio && <>({getUnitType(it)})</>}
                                            </MenuItem>)
                                        })}
                                    </Select>}
                                    {isBio && _id && <>
                                        <Select size={'small'}
                                                value={avalue.signalIndex} onChange={(e) => {
                                            setAssignedValues({
                                                ...assignedValues,
                                                [it]: {...avalue || {}, signalIndex: e.target.value}
                                            })
                                        }}>
                                            {(signalColors || []).map((it, ind) => {

                                                return (<MenuItem key={ind} value={ind}>
                                                    <PreviewColor it={it} ind={ind}
                                                                  signals={signalColors}></PreviewColor>
                                                </MenuItem>)
                                            })}
                                        </Select>
                                    </>}
                                </td>
                            </tr>)

                        })}
                    </table>
                </>}


                {stage == 'preview' && <>
                    <NextPrev prev={'config'} next={'disabled'} setStage={setStage} onClose={onClose}></NextPrev>
                    <div className="pull-right">

                        <button
                            className={'btn big'}
                            onClick={migrate}
                        >
                            Migrate
                        </button>
                    </div>

                    <Select
                        size='small'
                        value={filter.sortBy || 'ind'} onChange={(e) => {
                        setFilter({...filter, sortBy: e.target.value})
                    }}>
                        <MenuItem value={'ind'}>Default</MenuItem>
                        <MenuItem value={'checked'}>By Selected</MenuItem>
                    </Select>
                    <label style={{marginLeft: '10px'}}>
                    <Checkbox onClick={() => {
                        setChecked(!checked)
                        console.log("qqqqq checkedddd", checkboxes, !checked);
                        if (!checked) {
                            let obj: any = {};
                            _.each(parsed, (item, ind) => {
                                let key = (ind + 1).toString();
                                obj[key] = true;
                            })
                            setCheckboxes(obj)

                        } else {
                            setCheckboxes({})
                        }
                    }} checked={checked} /> Select All
                    </label>

                    <table className={'table'} style={{marginTop: '7px'}}>
                        {_.sortBy(parsed, (it, ind) => {
                            let sortBy = filter.sortBy || 'ind';
                            return sortBy == 'ind' ? (1) * it.ind : ((checkboxes as any)[it.ind as any] ? 10 : 100)
                        }).map((it) => {
                            let ind = it.ind;
                            return (<tbody key={ind}>
                            <PreviewParsedValue it={it}
                                                indicators={indicators}
                                                checkboxes={checkboxes}
                                                onChange={(v: any) => {
                                                    console.log("qqqqq set checkboxes!!!",);
                                                    setCheckboxes({...checkboxes || {}, [ind]: v})
                                                }}></PreviewParsedValue>
                            </tbody>)
                        })}


                    </table>

                </>}
                {/*<pre>*/}
                {/*    {JSON.stringify(checkboxes, null, 4)}*/}
                {/*</pre>*/}
            </div>
        </DialogMUI>

        {/*    <hr/>*/}
        {/*    {JSON.stringify(assignedValues, null, 4)}*/}
        {/*    /!*<hr/>*!/*/}
        {/*    {JSON.stringify(filter, null, 4)}*/}
        {/*    /!*{JSON.stringify(uniqueValuesArr, null, 4)}*!/*/}


        {/*    /!*<hr/>*!/*/}
        {/*    /!*{JSON.stringify(filter, null, 4)}*!/*/}
        {/*    /!*{JSON.stringify(csvArr, null, 4)}*!/*/}
        {/*</pre>*/}
    </>)
}

const NextPrev = ({prev, next, setStage, onClose}: { setStage: any, prev: string, next: string, onClose: any }) => {
    return <div style={{animation: 'none', display: 'block', opacity: '1'}}>
        <button className={'btn big'} disabled={prev === 'disabled'} onClick={() => {
            setStage(prev)
        }}>Back
        </button>
        <button className={'btn big'} disabled={next === 'disabled'} onClick={() => {
            setStage(next)
        }}>Next
        </button>
        <div className="pull-right pointer" onClick={() => {
            onClose()
        }}>
            <CloseIcon></CloseIcon>
        </div>
        <hr/>
    </div>
}

const getNameInd = (ind: number) => {
    return '#' + (ind + 1)
}

const PreviewColor = (props: any) => {
    let {it, ind, signals} = props || {};
    let ind2Key = ind > 2 ? '2' : 1;
    let scaleName = signals.map((it: any) => it.name).join('');
    let names: any = {
        'RAG': ['L', 'mL', 'O'],
        'GAR': ['O', 'mH', 'H']
    }
    let sName = (names[scaleName] || [])[ind] || ''

    let shortN = it['shortName' + (ind2Key)] || ''
    if (shortN == 'mL' && (signals[4] || {}).shortName2 == 'MH') {
        shortN = 'mmH'
    }
    console.log("qqqqq namessssssssssssss", names, scaleName, sName, shortN, it?.name);
    return <>
        <div style={{
            background: it?.color,
            width: '15px',
            height: '15px',
            display: 'inline-block'
        }}></div>
        <span style={{marginLeft: '10px'}}>{sName || shortN || it?.name || getNameInd(ind)}</span>
    </>
}


const PreviewParsedValue = (props: any) => {
    let {it, checkboxes, onChange, indicators} = props;
    let [open, setOpen] = useState(false)

    let ind = it.ind;

    console.log("qqqqq checkboxes", checkboxes, it);
    return <>
        <tr>
            <td style={{width: '100px'}}>
                №{ind}
            </td>
            <td>

                <Checkbox key={'checkbox_' + ind + (checkboxes[ind] ? 'yes' : 'no')} checked={checkboxes[ind]}
                          onChange={v => {
                              console.log("qqqqq on Change checkbox", v);
                              onChange(v.target.checked)
                          }}></Checkbox>


                {/*{checkboxes[ind] ? 'yes' : 'no'}*/}
            </td>

            <td>
                {it.hashName}
            </td>
            <td>
                {(Object.keys(it.byCheckboxes) || []).map((indicatorId, ind) => {
                    let indic = indicators[indicatorId] || {}
                    let signals = Object.keys(it.byCheckboxes[indicatorId]);
                    const signalColors = getScaleTypeColor(indic.scaleType?.name || 'RAGAR')

                    return (<div key={ind} style={{whiteSpace: 'normal'}}>
                        <div className="ib">
                            {typeof indic?.name === 'object' 
                                ? indic.name?.en || indic.name?.[Object.keys(indic.name || {})[0]] || ''
                                : indic?.name || ''}
                        </div>
                        <div className="ib">
                            {(signals || []).map((signalInd, ind) => {
                                let key = +signalInd as number;
                                return (<div key={ind} style={{marginLeft: '5px', display: 'inline-block'}}>
                                    <PreviewColor ind={signalInd} it={(signalColors || {})[key]}
                                                  signals={signals}></PreviewColor>
                                </div>)
                            })}

                        </div>

                    </div>)
                })}
            </td>
            <td style={{width: '100px'}}>
                <a
                    onClick={() => {
                        setOpen(!open)
                    }} style={{cursor: 'pointer', marginRight: '10px'}}>details</a>
            </td>
        </tr>
        {open && <tr>
            <td colSpan={4}>
                {open && <>
                    {it.names}
                </>}
                {/*{JSON.stringify(it, null, 4)}*/}
            </td>
        </tr>}


    </>

}


const IndFilter = (props: any) => {
    let {name, setFilter, filter, field, indexes} = props;
    let letters = [''];

// Loop through character codes of 'A' to 'Z'
    for (let i = 65; i <= 90; i++) {
        letters.push(String.fromCharCode(i)); // Convert character code to letter and push to the array
    }
    return <div>
        <b>{name}:</b> <Select
        size={'small'}
        value={filter[field]} onChange={e => {
        setFilter({...filter, [field]: e.target.value as string})
    }}>
        {(letters || []).map((it: any, ind: number) => {
            return (<MenuItem key={ind} value={ind}>
                {it || '--'}
            </MenuItem>)
        })}


    </Select></div>
}


export default CSVUploader
